module.exports = __webpack_public_path__ + "static/media/img-thumbnail-sushi-03.227ae3b5.webp";